import { EditorController } from '@ibiz-template/runtime';
import { IStepper } from '@ibiz/model-core';

/**
 * 步进器编辑器控制器
 *
 * @export
 * @class StepperEditorController
 * @extends {EditorController}
 */
export class StepperEditorController extends EditorController<IStepper> {}
